// WithdrawDetail.jsx
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import RequestConfig from "../../mini_components/RequestConfig";
import { convertToJalali } from "../../mini_components/ConvertToJalali";
import NumericFormat from "react-number-format";
import ValueFinder from "../../shared/ValueFinder";
import { adminStatusList, userStatusList } from "../../lib/constants";
import Loader from "../../shared/Loader";
import Button from "../../ui/Button";

// 💡 Field Components
const Field = ({ label, children }) => (
  <div className="flex justify-between items-center text-[14px] font-semibold w-full p-1">
    <label className="w-[150px] text-end">{label}</label>
    <div className="w-full text-center">{children || "-"}</div>
  </div>
);

const DateField = ({ label, value }) => (
  <Field label={label}>{value ? convertToJalali(value) : "-"}</Field>
);

const AmountField = ({ label, value }) => (
  <Field label={label}>
    <NumericFormat value={value} displayType="text" thousandSeparator /> ریال
  </Field>
);

const StatusField = ({ label, title, data }) => (
  <Field label={label}>
    <ValueFinder title={title} data={data} />
  </Field>
);

// 💡 Main Component
const WithdrawDetail = () => {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const { state } = useLocation();

  useEffect(() => {
    const fetchDetail = async () => {
      const url = state?.internal
        ? `/internal_withdraws/${id}/`
        : `/withdraws/${id}/`;
      try {
        const response = await RequestConfig.get(url);
        if (response.status === 200) setItem(response.data);
      } catch (err) {
        console.error(err);
        
      } finally {
        setLoading(false);
      }
    };
    fetchDetail();
  }, [id]);

  const handleReceive = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const response = await RequestConfig.get(`withdraws/recipe/url/${id}/`);
      if ([200, 201].includes(response.status)) {
        window.open(response.data.file_url, "_blank");
      }
    } catch (error) {
      console.error("Error processing form:", error);
    }
  };

  if (loading)
    return (
      <div className="w-full h-full flex justify-center items-center min-h-[400px]">
        <Loader />
      </div>
    );
  if (!item) return <div>درحال بارگزاری اطلاعات ...</div>;

  return (
    <div className="figure-wrapper gap-2">
      <p className="text-[18px] text-center font-bold p-6">انتقال‌وجه </p>

      <DateField label="تاریخ درخواست" value={item.created_at} />
      <DateField label="تاریخ آخرین ویرایش" value={item.updated_at} />
      <AmountField label="مبلغ" value={item.amount} />
      <Field label="شماره شبای مقصد">{item.destination_iban}</Field>
      <Field label="نام صاحب مقصد">{state.internal?item.recipient:item.destination_name}</Field>
      <Field label="نام بانک مقصد">{item.destination_bank}</Field>
      <DateField label="تاریخ پرداخت" value={item.payment_time} />
      <Field label="کد رهگیری">{item.tracking_code}</Field>
      <StatusField
        label="وضعیت پرداخت"
        title={item.status}
        data={userStatusList}
      />
      <Field label="توضیحات پرداخت">{item.description}</Field>
      <StatusField
        label="وضعیت ادمین"
        title={item.admin_status}
        data={adminStatusList}
      />
      <Field label="توضیحات ادمین">{item.admin_description}</Field>

      <Button
        className="w-full px-6 py-2 border-2 bg-white border-dark hover:bg-slate-200 text-dark rounded-[12px] font-bold mt-8"
        tabIndex="-1"
        onClick={(e) => handleReceive(e, item.id)}
      >
        دریافت رسید پرداخت
      </Button>
    </div>
  );
};

export default WithdrawDetail;
